import React from 'react';

import { ExistingStudentWidgetProps } from '../Widget';
import { DividerWidget as DividerWidgetModel } from '@ael/core-api';
import classNames from 'classnames';

export const DividerWidget = (props: ExistingStudentWidgetProps) => {
  const widget = props.widget as DividerWidgetModel;

  return (
    <div
      className={classNames('uno-w-full', {
        'uno-h-[1px]': widget.value.properties?.thickness === 's',
        'uno-h-[2px]': widget.value.properties?.thickness === 'm',
        'uno-h-[4px]': widget.value.properties?.thickness === 'l',
      })}
      style={{ backgroundColor: widget.value.properties?.color }}
    />
  );
};
